import * as tslib_1 from "tslib";
import { Directive, TemplateRef } from '@angular/core';
import * as ɵngcc0 from '@angular/core';
let RenderEmptyDirective = class RenderEmptyDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
};
RenderEmptyDirective.ɵfac = function RenderEmptyDirective_Factory(t) { return new (t || RenderEmptyDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
RenderEmptyDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: RenderEmptyDirective, selectors: [["", "renderEmpty", ""]] });
RenderEmptyDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RenderEmptyDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[renderEmpty]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
export { RenderEmptyDirective };
